import {
	dispatchAcknowledgedEvent,
	openResourceSection,
} from '../../core/resourceEvents';
import {
	PORT_RANGE_FOCUS_EVENT,
	PORT_RANGE_SECTION_EVENT,
} from './events';

const SECTIONS = new Set(['profile.port_ranges']);

/**
 * Open Access Controls and bring Port Range into view.
 *
 * Five collections share this one accordion, and two of them are behind an
 * inner tab pair, so the section is named per collection rather than per
 * accordion - the page selects the tab when it needs to.
 *
 * @return {Promise<void>} completion acknowledgement
 */
export function openPortRangeSection() {
	return openResourceSection(
		PORT_RANGE_SECTION_EVENT,
		'profile.port_ranges',
		SECTIONS,
	);
}

/**
 * Point at one Port Range row in the table.
 * @param {string} entityId identifier
 * @return {Promise<void>} acknowledgement
 */
export function focusPortRange(entityId) {
	if (!entityId) return Promise.reject(new Error('invalid_port_range_focus'));
	return dispatchAcknowledgedEvent(PORT_RANGE_FOCUS_EVENT, {
		entityId: String(entityId),
		resource: 'port_range',
	});
}
